import { ActivatedRoute } from '@angular/router';
import { LoadingPage } from 'app/shared/components/loading/loading.page.component';
import { Component, OnInit } from '@angular/core';
import { CatalogProductsService } from 'app/core/services/catalog-products.service';
import { DomainService } from 'app/core/services/domain.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'itpx-event-listing',
  templateUrl: './event-listing.component.html',
  styleUrls: ['../common/style.css']
})
export class EventListingComponent extends LoadingPage implements OnInit {
  private domain: any;
  private backgroundUrl$: Observable<string>;
  private licenses$: Observable<any>;

  constructor(private route: ActivatedRoute, 
    private service: CatalogProductsService,
    private domainService: DomainService,
    ) {
    super();
  }

  ngOnInit() {
  this.loading();
  this.backgroundUrl$ = this.domainService.getBanner();
  this.domain = this.domainService.getDomain();
    const courseId = this.route.snapshot.paramMap.get('id');
    this.licenses$ = this.service.getCourseEvents(courseId).map(res => {
      res.data.forEach(event => {
        event.classEvent['type']='event';
        event.classEvent.displayName=event.course.name;
        event.classEvent.name=event.course.name;
        return event.classEvent;
      });
      return res.data.map(event => event.classEvent);
    }).neverError().bindToLifecycle(this).shareReplay(1);
    this.licenses$.subscribe(val => console.log(val));
    this.ready();
  }
  
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/event-listing/event-listing.component.ts